import { loadMessages, locale } from 'devextreme/localization';
import type { LocaleType } from '@mts-fe/utils';

/** 动态切换 DevExtreme 组件语种 */
export async function changeDevExtremeLocale(localeType: LocaleType) {
  try {
    const msgModule = await import(`./${localeType}.json`);
    const messages = msgModule.default;
    loadMessages(messages);

    const [dxLocale] = Object.keys(messages);
    locale(dxLocale);
  } catch {
    const enModule = await import('./zh-CN.json');
    loadMessages(enModule.default);
    locale('zh');
  }
}
